{
  "search": "חפש",
  "searchWithin": "חפש בתוך"
}
